import { createFileRoute } from "@tanstack/react-router";
import AdminPartsCategoryMapper from "@/pages/admin/AdminPartsCategoryMapper";

export const Route = createFileRoute("/_adminLayout/admin/parts/category-mapper")({
  component: AdminPartsCategoryMapper,
});
